import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { DEFAULT_TEXT } from "@/data/siteText";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FALLBACK = {
    socials: [
        { platform: "instagram", url: "https://www.instagram.com/ayevibemuzik", label: null },
        { platform: "tiktok", url: "https://www.tiktok.com/@therealayevibemuzik", label: null },
        { platform: "youtube", url: "https://www.youtube.com/@ayevibemuzik", label: null },
    ],
    text: {},
    announcement: { enabled: false, text: "", link_url: "", link_label: "" },
};

const SiteSettingsContext = createContext(FALLBACK);

export const SiteSettingsProvider = ({ children }) => {
    const [settings, setSettings] = useState(FALLBACK);

    useEffect(() => {
        axios
            .get(`${API}/site-settings`)
            .then((res) => setSettings({ ...FALLBACK, ...res.data }))
            .catch(() => {});
    }, []);

    return <SiteSettingsContext.Provider value={settings}>{children}</SiteSettingsContext.Provider>;
};

export const useSite = () => {
    const settings = useContext(SiteSettingsContext);
    const t = (key) => (settings.text?.[key]?.trim?.() ? settings.text[key] : DEFAULT_TEXT[key]);
    return { ...settings, t };
};

export default SiteSettingsProvider;
